angular.module('logbook')
.directive('condensedText', ['$timeout', '$window', function($timeout, $window ) {
   return {
      restrict: 'E',

      scope: {
         text: '=',
         maxLines: '=?',
         lineHeight: '=?',
         textClass: '@',
         textStyle: '@',
         displayAll: '=?',
         displayToggle: '=?',
         disableToggle: '=?',
         watchText: '=',
         showMorePostscript: '=',
         showMorePostscriptStyle: '=',
         alwaysShowToggle: '=',
         textIsTruncated: '=?',
         truncatedTextIndicator: '='
      },

	  template: require('./condensed-text.html'),

      link: function(scope, elem, attrs) {
         scope.allFragments = scope.text.split('\n');
         scope.html = scope.text;
         if( scope.watchText )
            scope.$watch('text', function() {
               scope.allFragments = scope.text ? scope.text.split('\n') : [];
               scope.html = scope.text;
            });
         
         $timeout(function() {
            $('#text-container-'+scope.$id).find('img').on('load', function() {
               scope.setDisplay(scope.displayAll);
            });
         });

         scope.charCounts = scope.allFragments.map(function(fragment) {
            return fragment.length;
         });

         if( !scope.maxLines )
            scope.maxLines = 2;
         if( !scope.lineHeight )
            scope.lineHeight = 1.2;
         
         scope.testStyle = {
            'height':(scope.lineHeight*scope.maxLines)+'em',
            'overflow':'hidden',
            'line-height':scope.lineHeight+'em'};
         
         scope.setDisplay = function(all)
         {
            scope.displayAll = all;
            if( all )
            {
               scope.displayedFragments = scope.allFragments;

               scope.style={
                     'max-height':'initial',
                     'overflow':'hidden',
                     'line-height':scope.lineHeight+'em'
               };
               
               $timeout(function() {
                  scope.textIsTruncated =
                     $('#text-container-'+scope.$id).prop('scrollHeight')
                     > $('#size-test-'+scope.$id).prop('scrollHeight');
                  scope.displayToggle = scope.textIsTruncated || scope.alwaysShowToggle;
               });
               
               scope.toggleLabel = 'Show Less';
            }
            else
            {
               scope.style = {
                     'max-height':(scope.lineHeight*scope.maxLines)+'em',
                     'overflow':'hidden',
                     'line-height':scope.lineHeight+'em'
               };
               
               $timeout(function() {
                  scope.textIsTruncated = 
                     $('#text-container-'+scope.$id).prop('scrollHeight') 
                     > $('#size-test-'+scope.$id).prop('scrollHeight');;
                     scope.displayToggle = scope.textIsTruncated || scope.alwaysShowToggle;
               });
               
               scope.toggleLabel = 'Show More';
            }
               
         };
         
         scope.updateDisplayFunction = function() {
               scope.setDisplay(scope.displayAll);
         };
         
         angular.element($window).bind('resize', scope.updateDisplayFunction);
         
         scope.$on('$destroy', function() {
            angular.element($window).unbind('resize', scope.updateDisplayFunction);
         });

         scope.setDisplay(scope.displayAll);
      }
    };
  }]);
